import React from 'react';
import { Calendar, Clock, MapPin, Timer, Check, AlertTriangle } from 'lucide-react';
export function WebinarInfoCard() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 border-l-4 border-l-[#2563EB] p-8 my-10" data-id="element-155">
      <div className="flex items-center mb-8" data-id="element-156">
        <Calendar className="text-[#2563EB] mr-3" size={28} data-id="element-157" />
        <h3 className="text-2xl font-bold text-gray-900" data-id="element-158">
          Het volgende webinar
        </h3>
      </div>

      <div className="space-y-5 mb-8" data-id="element-159">
        <div className="flex items-center" data-id="element-160">
          <Calendar className="text-gray-400 mr-4 w-5 h-5" data-id="element-161" />
          <span className="text-gray-900 font-semibold w-24" data-id="element-162">Datum:</span>
          <span className="text-gray-600" data-id="element-163">Vandaag en morgen</span>
        </div>

        <div className="flex items-center" data-id="element-164">
          <Clock className="text-gray-400 mr-4 w-5 h-5" data-id="element-165" />
          <span className="text-gray-900 font-semibold w-24" data-id="element-166">Tijd:</span>
          <span className="text-gray-600" data-id="element-167">10:00, 13:00 & 20:00</span>
        </div>

        <div className="flex items-center" data-id="element-168">
          <MapPin className="text-gray-400 mr-4 w-5 h-5" data-id="element-169" />
          <span className="text-gray-900 font-semibold w-24" data-id="element-170">Locatie:</span>
          <span className="text-gray-600" data-id="element-171">Online</span>
        </div>

        <div className="flex items-center" data-id="element-172">
          <Timer className="text-gray-400 mr-4 w-5 h-5" data-id="element-173" />
          <span className="text-gray-900 font-semibold w-24" data-id="element-174">Duur:</span>
          <span className="text-gray-600" data-id="element-175">90 minuten</span>
        </div>

        <div className="flex items-center" data-id="element-176">
          <Check className="text-green-500 mr-4 w-5 h-5" strokeWidth={3} data-id="element-177" />
          <span className="text-gray-900 font-semibold w-24" data-id="element-178">Kosten:</span>
          <span className="text-green-600 font-bold" data-id="element-179">100% GRATIS</span>
        </div>
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 flex items-start" data-id="element-180">
        <AlertTriangle className="text-amber-500 w-5 h-5 mr-3 flex-shrink-0 mt-0.5" data-id="element-181" />
        <p className="text-sm text-amber-800 font-medium leading-relaxed" data-id="element-182">
          Belangrijk: Er zijn beperkte plekken beschikbaar per uitzending.
        </p>
      </div>
    </div>;
}